import { render, staticRenderFns } from "./vehiculo.vue?vue&type=template&id=c9512606&"
import script from "./vehiculo.vue?vue&type=script&lang=js&"
export * from "./vehiculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer})
